import { Box, Typography } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { useStyles } from './styles';

export function InfoBanner({ lines }) {
  const classes = useStyles();

  return (
    <Box className={classes.infoBanner}>
      <InfoOutlined className={classes.infoBannerIcon} />
      <Box>
        {lines.map((line) => (
          <Typography key={line} variant="body2" className={classes.infoBannerText}>
            {line}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}